import { TERMINOS_TEXTO, TERMINOS_TITULO, TERMINOS_VERSION, buildDeclaracionResumen } from '../constants/firma-legal';
import { isFirmaDedoEnabled } from '../config/firma-config';
import { $, escapeHtml } from '../utils/dom';

export function isFirmaLegalAccepted(): boolean {
  const el = $('legal-accept') as HTMLInputElement | null;
  return el?.checked === true;
}

export function bindFirmaLegalAcceptance(onChange: () => void): void {
  $('legal-accept')?.addEventListener('change', onChange);
}

export function renderFirmaLegalBlock(grano: string, kilos: number, onChange: () => void): void {
  const block = $('legal-block');
  if (!block) return;
  block.innerHTML =
    '<div class="legal-block">' +
    '<h3 class="legal-block__title">' +
    escapeHtml(TERMINOS_TITULO) +
    '</h3>' +
    '<p class="legal-block__text">' +
    escapeHtml(TERMINOS_TEXTO) +
    '</p>' +
    '<p class="legal-block__resumen">' +
    escapeHtml(buildDeclaracionResumen(grano, kilos)) +
    '</p>' +
    '<label class="legal-block__check">' +
    '<input type="checkbox" id="legal-accept" />' +
    '<span>Leí y acepto la declaración jurada (v.' +
    escapeHtml(TERMINOS_VERSION) +
    ')</span>' +
    '</label>' +
    '</div>';
  bindFirmaLegalAcceptance(onChange);
}

export function updateConfirmSubmitEnabled(signatureEmpty: boolean): void {
  const btn = $('btn-confirm-submit') as HTMLButtonElement | null;
  if (!btn) return;
  const needsSignature = isFirmaDedoEnabled();
  btn.disabled = (needsSignature && signatureEmpty) || !isFirmaLegalAccepted();
  if (btn.textContent !== 'Enviando…') {
    btn.textContent = needsSignature ? 'Firmar y enviar' : 'Confirmar y enviar';
  }
}
